var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { GUTTER_HALF, MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var colValues = {
  columnOneThird: '33.3333%',
  columnTwoThirds: '66.6667%',
  columnOneQuarter: '25%',
  columnOneHalf: '50%'
};
var StyledColumn = styled('div')((_styled = {
  marginBottom: SPACING.SCALE_3,
  boxSizing: 'border-box'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  marginRight: GUTTER_HALF,
  marginLeft: GUTTER_HALF,
  ':first-child': {
    marginLeft: 0
  },
  ':last-child': {
    marginRight: 0
  }
}, _styled), function (_ref) {
  var hideContent = _ref.hideContent;

  if (!hideContent) {
    return false;
  }

  return {
    textIndent: '-999em',
    backgroundColor: '#7DADD3',
    backgroundImage: 'repeating-linear-gradient(180deg, #7DADD3, #7DADD3 15px, #B7CFE1 15px, #B7CFE1 30px)'
  };
}, function (props) {
  var _ref3;

  var widthValue = 'auto';
  var hasRequestedWidth = false;
  Object.entries(props).forEach(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];

    if (colValues[key] && value === true) {
      widthValue = colValues[key];
      hasRequestedWidth = true;
    }
  });
  return _ref3 = {}, _ref3[MEDIA_QUERIES.LARGESCREEN] = {
    flexGrow: hasRequestedWidth ? 0 : 1,
    width: widthValue
  }, _ref3;
});
/**
 *
 * Should always be wrapped by `GridRow`. Will always render a column at 100% width if
 * the browser width is below the `LARGESCREEN` breakpoint.
 *
 * ### Usage
 *
 * Example
 * * https://codesandbox.io/s/x917knwm4z
 *
 * Simple
 * ```jsx
 * import GridRow from '@govuk-react/grid-row';
 * import GridCol from '@govuk-react/grid-col';
 *
 * <Fragment>
 *   <GridRow>
 *     <GridCol>
 *       ...
 *     </GridCol>
 *   </GridRow>
 *   <GridRow>
 *     <GridCol columnOneHalf>
 *       ...
 *     </GridCol>
 *     <GridCol columnOneQuarter>
 *       ...
 *     </GridCol>
 *     <GridCol columnOneQuarter>
 *       ...
 *     </GridCol>
 *   <GridRow>
 *     <GridCol columnOneThird>
 *       ...
 *     </GridCol>
 *     <GridCol columnTwoThirds>
 *       ...
 *     </GridCol>
 *   </GridRow>
 * </Fragment>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/_grid_layout.scss
 * - https://github.com/alphagov/govuk_elements/blob/master/assets/sass/elements/_layout.scss
 *
 */

var GridCol = function GridCol(_ref4) {
  var columnOneThird = _ref4.columnOneThird,
      columnTwoThirds = _ref4.columnTwoThirds,
      columnOneQuarter = _ref4.columnOneQuarter,
      columnOneHalf = _ref4.columnOneHalf,
      props = _objectWithoutProperties(_ref4, ["columnOneThird", "columnTwoThirds", "columnOneQuarter", "columnOneHalf"]);

  return React.createElement(StyledColumn, _extends({
    columnOneThird: columnOneThird,
    columnTwoThirds: columnTwoThirds,
    columnOneQuarter: columnOneQuarter,
    columnOneHalf: columnOneHalf
  }, props));
};

GridCol.defaultProps = {
  children: undefined,
  columnOneThird: false,
  columnTwoThirds: false,
  columnOneQuarter: false,
  columnOneHalf: false
};
export default GridCol;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/grid-col/es/index.js
// module id = 264
// module chunks = 0